import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const RorligtPris = lazy(() => import("@/pages/elavtal/RorligtPris"));

export const Route = createFileRoute("/elavtal/rorligt")({
  head: () => seoHead("/elavtal/rorligt"),
  component: () => <RorligtPris />,
});
